import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    Card,
} from 'components/other';

import styles from './StageCard.module.scss';

const StageCard: FC<IProps> = (props) => {
    return (
        <Card className={classNames(styles.stageCard, props.className)}>
            <div className={styles.top}>
                <div className={styles.number}>
                    {props.number}
                </div>
                <div className={styles.title}>
                    {props.title}
                </div>
            </div>
            <div className={styles.description}>
                {props.description}
            </div>
            <div className={styles.content}>
                {props.children}
            </div>
        </Card>
    );
};

export default StageCard;
